import React from "react";
import classNames from "classnames";
import { useDragAndDrop } from "@common/dragAndDrop";
import { Resource } from "@pages/planzoneMembersPage/resource";
import { Props } from "./types";
import styles from "./styles.scss";

function ResourcesList({ resources, depth, columns }: Props) {
  const { isDragging } = useDragAndDrop();

  if (resources.length === 0) return null;

  return (
    <ul
      className={classNames(styles.resourcesList, styles[`depth${depth}`], {
        [styles.passThrough]: isDragging,
      })}
    >
      {resources.map((resource) => (
        <li key={resource.uuid} className={styles.item}>
          <Resource resource={resource} columns={columns} isCompact />
        </li>
      ))}
    </ul>
  );
}

export { ResourcesList };
